const STORAGE_KEY = "tms_fileManagerClipboard";

const normalizeIds = ids =>
  (Array.isArray(ids) ? ids : []).filter(id => id !== null && id !== undefined && id !== "");

const readRaw = () => {
  try {
    // localStorage is shared across tabs/windows on the same origin.
    // sessionStorage is per-window, so opening Scoop B in a new/recreated
    // FileManagerPopup would lose the clipboard — fall back for migration.
    return localStorage.getItem(STORAGE_KEY) || sessionStorage.getItem(STORAGE_KEY);
  } catch {
    return null;
  }
};

export const getFileManagerClipboard = () => {
  try {
    const raw = readRaw();
    if (!raw) return [];
    const parsed = JSON.parse(raw);
    return normalizeIds(parsed);
  } catch {
    return [];
  }
};

export const setFileManagerClipboard = ids => {
  const normalized = normalizeIds(ids);
  try {
    if (normalized.length === 0) {
      localStorage.removeItem(STORAGE_KEY);
      sessionStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
      // Clear legacy sessionStorage key so stale empty/old values cannot win.
      sessionStorage.removeItem(STORAGE_KEY);
    }
  } catch {
    // Ignore quota / private-mode failures; in-memory state still works in-session.
  }
  return normalized;
};

export const clearFileManagerClipboard = () => setFileManagerClipboard([]);
